module.exports = __webpack_public_path__ + "img/star.184b2fb1.svg";